export default {
  install(app, { store }) {
    app.config.globalProperties.$roles = {
      ADMIN: 10,
      CONSULTANT: 11,
      HR: 20,
      FOREIGNER: 30,
      FAMILY: 31,
      AGENCY: 40,
    };

    app.config.globalProperties.$isInRole = (roles) => {
      const me = store.state.v2.shared.profile.me;
      return (
        roles &&
        roles.some((role) => app.config.globalProperties.$roles[role] === me.role)
      );
    };

    app.config.globalProperties.$notificationTypes = {
      ANY: 0,
      SEEN: 1,
      UNSEEN: 2,
    };
  },
};
